import type { Viewer } from '@cesiumgs/cesium-analytics'
import type DrawAction from './DrawAction'
import DrawCircleAction from './DrawCircleAction'
import DrawLineAction from './DrawLineAction'
import type { DrawOptions } from './DrawOptions'
import DrawPointAction from './DrawPointAction'
import DrawPolygonAction from './DrawPolygonAction'
import DrawRectAction from './DrawRectAction'
import { DrawType } from './DrawType'

/**
 * Cesium Tools for draw point, line, polygon, rectangle, circle
 * @example
 * ```typescript
 * let draw=new Draw(view);
 * draw.create(DrawType.Point,null);
 * draw.on(DrawEventType.Complete,evt=>{
 * });
 * ```
 * @example
 * ```typescript
 * let draw=new Draw(view);
 * draw.create(DrawType.Polyline,null);
 * draw.on(DrawEventType.Complete,evt=>{
 * });
 * ```
 * @example
 * ```typescript
 * let draw=new Draw(view);
 * draw.create(DrawType.Polygon,null);
 * draw.on(DrawEventType.Complete,evt=>{
 * });
 * ```
 * @example
 * ```typescript
 * let draw=new Draw(view);
 * draw.create(DrawType.Circle,null);
 * draw.on(DrawEventType.Complete,evt=>{
 * });
 * ```
 * @example
 * ```typescript
 * let draw=new Draw(view);
 * draw.create(DrawType.Rect,null);
 * draw.on(DrawEventType.Complete,evt=>{
 * });
 * ```
 */
export default class Draw {
  /**
   * view instance
   *
   * @private
   * @type {Viewer}
   * @memberof Draw
   */
  private viewer: Viewer
  /**
   * current draw action
   *
   * @private
   * @type {DrawAction}
   * @memberof Draw
   */
  private currentAction?: DrawAction
  /**
   *
   * @param {Viewer} viewer input viewer
   *
   */
  constructor(viewer: Viewer) {
    this.viewer = viewer
  }

  /**
   * Create action based on Drawtype and optons
   * @param {DrawType} type DrawType:Line,Point,Polygon ...
   * @param {DrawOptions} options DrawOptions for action
   * @returns
   */
  public create(type: DrawType, options?: DrawOptions): DrawAction {
    this.reset()
    switch (type) {
      case DrawType.Polyline:
        this.currentAction = new DrawLineAction(this.viewer, options)
        break
      case DrawType.Point:
        this.currentAction = new DrawPointAction(this.viewer, options)
        break
      case DrawType.Polygon:
        this.currentAction = new DrawPolygonAction(this.viewer, options)

        break
      case DrawType.Circle:
        this.currentAction = new DrawCircleAction(this.viewer, options)
        break
      case DrawType.Rect:
        this.currentAction = new DrawRectAction(this.viewer, options)
        break
    }
    return this.currentAction
  }

  /**
   * Rest the action
   */
  public reset(): void {
    this.currentAction?.clear()
    this.currentAction = undefined
  }

  /**
   * Clear Draw Entity
   */
  protected clear(): void {
    this.currentAction?.clearEntity()
  }

  /**
   * overridden by subclasses
   */
  public destroy(): void {}
  /**
   * Will remove all Listener and entity
   */
  protected complete(): void {
    this.currentAction?.complete()
    if (!this.currentAction?.drawoptions?.mutilEntities)
      this.reset()
  }
}
